import { Component, type ReactNode } from 'react';
import { reportCrash } from '../lib/crash';

/**
 * Last line of defense: a render crash anywhere below unmounts React's whole
 * tree, and the user sees a silent blank page (exactly what an old bundle
 * did when the API dropped a field it still read). Catch it, report it, and
 * leave the person a way forward instead.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    reportCrash('crash', `render: ${error.message}`, error.stack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="page page-narrow center" style={{ paddingTop: 90 }}>
        <h2>Something went wrong</h2>
        <p className="t-md muted mt-2">
          This screen hit an error. Reloading usually fixes it — your funds, orders and positions
          live on the server and are unaffected.
        </p>
        <button className="btn btn-primary mt-3" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
